import { updateService } from "../HttpService";

// updateBus
export const updateBus = (id, formData) => {
  return updateService(`buses/${id}`, {}, formData);
};
